module.exports = __webpack_public_path__ + "img/cross.63ef92a9.svg";